'use strict';

module.exports.indexQuoteGrid = function () {
    const lastTradeDateTimeTitle = "data.pricedata.lasttradedatetime | momentjs 'true' 'MMM DD, YYYY'";

    return `
        <div rv-if="data.datatype | = 'index'">
            <div class="pure-g">
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-l">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-last"
                            rv-if="data.pricedata.last"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.last| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.last | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-change"
                            rv-if="data.pricedata.change"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.change| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.change | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-open"
                            rv-if="data.pricedata.open"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.open| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.open | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-high"
                            rv-if="data.pricedata.high"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.high| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.high | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-bid"
                            rv-if="data.pricedata.bid"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.bid| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.bid | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-week52low"
                            rv-if="data.fundamental.week52low"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.yearlow| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-popup-link"
                                        rv-on-click="data.togglePopup"
                                        data-popuptype="week52low"
                                        rv-text="data.fundamental.week52low.content | numeraljs"
                                    >
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-sharevolume"
                            rv-if="data.pricedata.sharevolume"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.volume| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.sharevolume | numeraljs '0,0'"
                                >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-r">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-lasttradedatetime"
                            rv-if="data.pricedata.lasttradedatetime"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.date| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-tooltip"
                                        rv-title="${lastTradeDateTimeTitle}"
                                        rv-on-mouseenter="data.qmtooltip"
                                        rv-text="data.pricedata.lasttradedatetime | momentjs 'true' 'h:mmA'"
                                    ></a>
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-changepercent"
                            rv-if="data.pricedata.changepercent"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.changepct| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-html="data.pricedata.changepercent | numeraljs '0.00' | postFix '%'"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-prevclose"
                            rv-if="data.pricedata.prevclose"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.prevclose| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.prevclose | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-low"
                            rv-if="data.pricedata.low"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.low| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.low | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-ask"
                            rv-if="data.pricedata.ask"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.ask| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.ask | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-week52high"
                            rv-if="data.fundamental.week52high"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.yearhigh| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-popup-link"
                                        rv-on-click="data.togglePopup"
                                        data-popuptype="week52low"
                                        rv-text="data.fundamental.week52high.content | numeraljs"
                                    >
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-exShName"
                            rv-if="data.key.exShName"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.exchange| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-tooltip"
                                        rv-title="data.key.exLgName"
                                        rv-on-mouseenter="data.qmtooltip"
                                        rv-text="data.key.exShName"
                                    >
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};
